
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import shrinkableMenu from "../components/shrinkable-menu/shrinkable-menu.vue";
import tagsPageOpened from "../components/tags-page-opened.vue";
import breadcrumbNav from "../components/breadcrumb-nav.vue";
import fullScreen from "../components/fullscreen.vue";
import lockScreen from "../components/lockscreen/lockscreen.vue";
import notice from "../components/notices/notice.vue";
import util from "../lib/util";
import copyfooter from "../components/Footer.vue";
import LanguageList from "../components/language-list.vue";
import AbpBase from "../lib/abpbase";
import * as proxy from "@/lib/service-proxies/service-proxies";
import appconst from '@/lib/appconst';
@Component({
  components: {
    shrinkableMenu,
    tagsPageOpened,
    breadcrumbNav,
    fullScreen,
    lockScreen,
    notice,
    copyfooter,
    LanguageList,
  },
})
export default class Main extends AbpBase {
  shrink: boolean = false;
  get userName() {
    return this.$store.state.session.user
      ? this.$store.state.session.user.name
      : "";
  }
  bindinglist=[];
  isFullScreen: boolean = false;
  messageCount: string = "0";
  tokenshow = false;
  tokenimg = "";
  isbindtoken = false;
  googlecode = "";
  googlekey = "";
  key = "";
  setting = new proxy.SystemSettingDto();
  get openedSubmenuArr() {
    return this.$store.state.app.openedSubmenuArr;
  }
  get menuList() {
    return this.$store.state.app.menuList;
  }
  get pageTagsList() {
    return this.$store.state.app.pageOpenedList as Array<any>;
  }
  get currentPath() {
    return this.$store.state.app.currentPath;
  }
  get lang() {
    return this.$store.state.app.lang;
  }
  get avatorPath() {
    return localStorage.avatorImgPath;
  }
  get cachePage() {
    return this.$store.state.app.cachePage;
  }
  get menuTheme() {
    return this.$store.state.app.menuTheme;
  }
  get mesCount() {
    return this.$store.state.app.messageCount;
  }

  okbind() {
    new proxy.GoogleTokenServiceProxy()
      .bindToken(this.googlekey, this.googlecode)
      .then((x) => {
        this.$Notice.success({ title: "绑定成功" });
        this.tokenshow = false;
        this.isbindtoken = true;
      });
  }
  init() {
    this.setting = window.abp.system;
    let pathArr = util.setCurrentPath(this, this.$route.name as string);
    this.$store.commit("app/updateMenulist");
    if (pathArr.length >= 2) {
      this.$store.commit("app/addOpenSubmenu", pathArr[1].name);
    }
    let messageCount = 3;
    this.messageCount = messageCount.toString();
    this.checkTag(this.$route.name);
    new proxy.GoogleTokenServiceProxy().isBind().then((p) => {
      this.isbindtoken = p;
      // console.log(this.setting);
      // console.log(this.isbindtoken);
      if (this.setting.isEnableGoogleCheckLogin) {
        if (!this.isbindtoken) {
          // this.$Modal.confirm({
          //   title: "温馨提示",
          //   content: "当前账户未绑定谷歌验证,存在风险,建议立即绑定",
          //   onOk: () => {

          //   },
          //   onCancel: () => {
          //     this.$Message.warning("当前账户未绑定谷歌验证,存在风险");
          //   },
          // });
          this.handleClickUserDropdown("bindtoken");
        } else {
          new proxy.MerchantClientServiceProxy().getMyInfo().then((x) => {
            if (!x.isUpdateLoginPwd) {
              this.$Modal.confirm({
                title: "温馨提示",
                content: "当前登录密码等级过低,存在风险,建议修改登录密码",
                onOk: () => {
                  this.$router.push({
                    path: "/setting/updateloginpwd",
                  });
                },
                onCancel: () => {
                  this.$Message.warning("当前登录密码等级过低");
                },
              });
            }
          });
        }
      }
    });
    new proxy.MerchantClientServiceProxy().queryBinDingsList().then(x=>{
        this.bindinglist = x;
    })
  }
  toggleClick() {
    this.shrink = !this.shrink;
  }
  qiehuanClickUser(name){
     new proxy.TokenAuthServiceProxy().qieHuanMerchantLogin(name).then(x=>{

      var tokenExpireDate = new Date(new Date().getTime() + 1000 * x.expireInSeconds);
      console.log(tokenExpireDate);
      abp.auth.setToken(x.accessToken, tokenExpireDate);
      abp.utils.setCookieValue(appconst.authorization.encrptedAuthTokenName, x.encryptedAccessToken, tokenExpireDate, abp.appPath)
      location.reload();
     })
  }
  handleClickUserDropdown(name: string) {
    if (name === "loginout") {
      this.$store.commit("app/logout", this);
      util.abp.auth.clearToken();
      location.reload();
    } else if (name == "bindtoken") {
      this.googlecode = "";
      new proxy.GoogleTokenServiceProxy().createToken().then((x) => {
        let json = JSON.parse(x);
        this.googlekey = json.googleKey;
        this.tokenimg = json.qrcode;
        this.key = json.key;
        this.tokenshow = true;
      });
    } else if (name == "cleartoken") {
      this.$Modal.confirm({
        render: (h) => {
          return h("Input", {
            props: {
              value: this.googlecode,
              autofocus: true,
              placeholder: "请输入谷歌令牌验证码",
            },
            on: {
              input: (val) => {
                this.googlecode = val;
              },
            },
          });
        },
        onOk: () => {
          new proxy.GoogleTokenServiceProxy()
            .clearToken(this.googlecode)
            .then((x) => {
              this.$Notice.success({ title: "解绑成功" });
              location.reload();
            });
        },
      });
    }
  }
  checkTag(name?: string) {
    let openpageHasTag = this.pageTagsList.some((item: any) => {
      if (item.name === name) {
        return true;
      } else {
        return false;
      }
    });
    if (!openpageHasTag) {
      util.openNewPage(
        this,
        name as string,
        this.$route.params || {},
        this.$route.query || {}
      );
    }
  }
  handleSubmenuChange(val: string) {
    // console.log(val)
  }
  beforePush(name: string) {
    if (name === "accesstest_index") {
      return false;
    } else {
      return true;
    }
  }
  fullscreenChange(isFullScreen: boolean) {
    // console.log(isFullScreen);
  }
  @Watch("$route")
  routeChange(to: any) {
    this.$store.commit("app/setCurrentPageName", to.name);
    let pathArr = util.setCurrentPath(this, to.name);
    if (pathArr.length > 2) {
      this.$store.commit("app/addOpenSubmenu", pathArr[1].name);
    }
    this.checkTag(to.name);
    localStorage.currentPageName = to.name;
  }
  @Watch("lang")
  langChange() {
    util.setCurrentPath(this, this.$route.name as string);
  }
  mounted() {
    this.init();
  }
  created() {
    this.$store.commit("app/setOpenedList");
  }
}
